import React, { ChangeEvent, HTMLProps } from 'react'
import InputWrapper, { InputWrapperProps } from './input-wrapper'
import { cn } from '../../lib/utils'
import { ratingOptions } from '../../constants/options'

type NumberRangeCheckboxInputProps = InputWrapperProps & Omit<HTMLProps<HTMLInputElement>, "onChange"> & {
    optionsWrapperClassName?: string,
    // TODO: REMOVE any type,
    // It will be fixed when we implement the form
    onChange: (value: number) => void,
}

/**
 * Checkbox input for number range from 1 to 5
 */
function NumberRangeCheckboxInput({
    wrapperClassName,
    label,
    labelClassName,
    error,
    errorClassName,
    optionsWrapperClassName,
    onChange,
    ...props
}: NumberRangeCheckboxInputProps) {

    return (
        <InputWrapper
            wrapperClassName={cn("gap-3", wrapperClassName)}
            label={label}
            labelClassName={labelClassName}
            error={error}
            errorClassName={errorClassName}
        >
            <div 
                className={cn(
                    'flex flex-nowrap items-center gap-2 sm:gap-6',
                    optionsWrapperClassName,
                )}
            >
                {ratingOptions.map((num) => {
                    // Color scheme matching Reports page: 1-3 = yellow, 4-5 = green
                    const getColorClasses = (value: number) => {
                        switch (value) {
                            case 1:
                            case 2:
                            case 3:
                                // Yellow tone matching Reports page (#D4A017)
                                return {
                                    checked: 'peer-checked:bg-[#D4A017] peer-checked:border-[#B88A14]',
                                    hover: 'hover:bg-[#D4A017]/10'
                                }
                            case 4:
                            case 5:
                                // Green tone matching Reports page (#3E7C59)
                                return {
                                    checked: 'peer-checked:bg-[#3E7C59] peer-checked:border-[#2E5D43]',
                                    hover: 'hover:bg-[#3E7C59]/10'
                                }
                            default:
                                return {
                                    checked: 'peer-checked:bg-primary peer-checked:border-foreground',
                                    hover: 'hover:bg-primary/10'
                                }
                        }
                    }

                    const colorClasses = getColorClasses(num)

                    return (
                        <div key={`${props.name}-${num}-checkbox-input`} className="shrink-0">
                            <input
                                {...props}
                                type="radio"
                                className='hidden peer'
                                id={`${props.name}-${num}-checkbox-input`}
                                value={num ?? ""}
                                checked={num === props.value}
                                onChange={() => onChange(num)}
                            />
                            <label
                                htmlFor={`${props.name}-${num}-checkbox-input`}
                                className={cn(
                                    'border aspect-square rounded-full w-8 min-w-8 flex items-center text-sm font-medium justify-center peer-checked:border-2 peer-checked:text-white cursor-pointer transition-colors sm:w-10 sm:min-w-10 sm:text-base',
                                    colorClasses.checked,
                                    colorClasses.hover
                                )}
                            >
                                {num}
                            </label>
                        </div>
                    )
                })}
            </div>
        </InputWrapper>
    )
}

export default NumberRangeCheckboxInput